export default "__VITE_ASSET__DaAIS5cS__"